module.exports = __webpack_public_path__ + "resources/img/img_docuone3.b9c92f30d6f4034e5384c921227cab77.png";